import { Link } from 'react-router'

import { OppPanel } from '../opp-panel/OppPanel'
import { PublicLayout } from './PublicLayout'

export const NotFoundPage = () => (
  <>
    <main>
      <PublicLayout>
        <h1>Page not found</h1>
        <p className="lead">
          The page you're looking for doesn't exist.{' '}
          <Link to="/">Try from here</Link>
        </p>
      </PublicLayout>
    </main>

    <OppPanel />
  </>
)
